import React from 'react'
import { MdEmail, MdQuestionAnswer, MdSms } from 'react-icons/md'
import './contact-preference-field.css'

const CONTACT_METHOD_DETAILS = {
    email: {
        Icon: MdEmail,
        label: 'Email',
        helper: 'This family responds best by email.',
        className: 'is-email',
    },
    text: {
        Icon: MdSms,
        label: 'Text',
        helper: 'This family responds best by text.',
        className: 'is-text',
    },
}

const ContactPreferenceField = ({
    card,
    saving = false,
    error = '',
    onChange,
}) => {
    const value = ['email', 'text'].includes(card?.preferredContactMethod)
        ? card.preferredContactMethod
        : ''
    const selectedMethod = CONTACT_METHOD_DETAILS[value]
    const Icon = selectedMethod?.Icon || MdQuestionAnswer

    return (
        <div className={`contact-preference-field ${selectedMethod?.className || ''}`}>
            <div className='contact-preference-field__icon' aria-hidden='true'>
                <Icon size={16} />
            </div>
            <div className='contact-preference-field__content'>
                <label
                    className='contact-preference-field__label'
                    htmlFor={`contact-preference-${card.todoId}`}
                >
                    Best response
                </label>
                <select
                    id={`contact-preference-${card.todoId}`}
                    className='contact-preference-field__select'
                    aria-label={`Best response method for ${card.todoName}`}
                    value={value}
                    disabled={saving}
                    onChange={(event) => onChange(event.target.value)}
                >
                    <option value='' disabled>
                        {saving ? 'Saving…' : 'Choose method…'}
                    </option>
                    <option value='email'>Email</option>
                    <option value='text'>Text</option>
                </select>
            </div>
            {error && (
                <div className='contact-preference-field__error' role='alert'>
                    {error}
                </div>
            )}
        </div>
    )
}

export default ContactPreferenceField
